<div class="page-grid-container fa-width-auto logistics-dashboard-page">
    <ng-template #filterHelp let-key="key" let-label="label">
        <span class="logistics-filter-help" tabindex="0"
            [attr.aria-label]="'About ' + (label || key) + ': ' + (logisticsFilterHelp[key] || 'Use this value to narrow the company search.')">
            <i class="fal fa-circle-info" aria-hidden="true"></i>
            <span class="logistics-filter-help__tip" role="tooltip">{{ logisticsFilterHelp[key] || 'Use this value to narrow the company search.' }}</span>
        </span>
    </ng-template>
        <header class="logistics-topbar logistics-page-topbar" [attr.inert]="logisticsFilterDrawerOpen ? '' : null">
            <div class="logistics-brand">
                <span class="logistics-brand__mark"><i class="fal fa-truck-fast"></i></span>
                <span><strong>ZINT</strong><small>Logistics intelligence</small></span>
                <span class="logistics-mode-badge"><i class="fal fa-route" aria-hidden="true"></i> Logistics mode</span>
            </div>
            <div class="logistics-topbar__actions">
                <button type="button" class="logistics-text-link" (click)="switchDashboardMode('full')">
                    Switch to full platform <i class="fal fa-arrow-up-right"></i>
                </button>
            </div>
        </header>

    <div class="logistics-layout" [class.has-searched]="logisticsHasSearched"
        [class.is-split]="logisticsHasSearched && !logisticsFiltersExpanded && !logisticsFiltersCollapsed"
        [class.is-collapsed]="logisticsFiltersCollapsed"
        [class.is-expanded]="logisticsFiltersExpanded"
        [class.is-drawer-open]="logisticsFilterDrawerOpen">
        @if (logisticsFilterDrawerOpen) {
        <button type="button" class="logistics-filter-backdrop" aria-label="Close filters"
            (click)="closeLogisticsFilterDrawer()"></button>
        }
    <section #logisticsFilterPane class="logistics-workspace" id="search-area" ngForm #searchForm="ngForm"
        tabindex="-1" [attr.role]="logisticsFilterDrawerOpen ? 'dialog' : null"
        [attr.aria-modal]="logisticsFilterDrawerOpen ? 'true' : null"
        [attr.aria-label]="logisticsFilterDrawerOpen ? 'Refine search filters' : null"
        (change)="queueLogisticsCriteriaRefresh()" (input)="queueLogisticsCriteriaRefresh()"
        (click)="queueLogisticsCriteriaRefresh()" (pointerup)="queueLogisticsCriteriaRefresh()"
        (keyup)="queueLogisticsCriteriaRefresh()">
        @if (logisticsHasSearched) {
        <div class="logistics-pane-actions">
            <span class="logistics-eyebrow">REFINE YOUR SEARCH</span>
            <button type="button" class="logistics-pane-expand" (click)="logisticsFiltersExpanded ? showLogisticsResults() : editLogisticsFilters()">
                <i class="fal" [ngClass]="logisticsFiltersExpanded ? 'fa-arrow-right' : 'fa-expand'"></i>
                {{ logisticsFiltersExpanded ? 'Show results' : 'Expand filters' }}
            </button>
            @if (!logisticsFiltersExpanded) {
            <button #logisticsCollapseFiltersButton type="button" class="logistics-pane-collapse"
                aria-label="Collapse filters and show full-width results" aria-controls="search-area"
                [attr.aria-expanded]="!logisticsFiltersCollapsed" (click)="collapseLogisticsFilters()">
                <i class="fal fa-chevron-left" aria-hidden="true"></i> Hide filters
            </button>
            }
            <button type="button" class="logistics-pane-close" (click)="closeLogisticsFilterDrawer()" aria-label="Close filters">
                <i class="fal fa-xmark"></i>
            </button>
        </div>
        }

        <section class="logistics-view" aria-labelledby="logistics-view-heading">
            <div class="logistics-view__heading">
                <div><span class="logistics-eyebrow">PROSPECT SEARCH</span><h1 id="logistics-view-heading">{{ logisticsHasSearched ? 'Refine your prospects' : 'Build your prospect list' }}</h1></div>
            </div>
            <div class="logistics-query-bar">
                <div>
                    <strong>{{ logisticsActiveFilterCount }} active {{ logisticsActiveFilterCount === 1 ? 'filter' : 'filters' }}</strong>
                    @if (logisticsHasPendingChanges) {
                    <small class="logistics-pending-label"><i class="fal fa-circle"></i> Changes not applied</small>
                    }
                </div>
                <div class="logistics-query-bar__actions">
                    <button type="button" class="logistics-reset-button" (click)="resetLogisticsFilters()">
                        <i class="fal fa-undo"></i> Reset
                    </button>
                    <button type="button" class="logistics-primary-button" (click)="runLogisticsSearch()"
                        [disabled]="isLoading().loadingUI || isLogisticsSearchLoading || isReadOnlyUser">
                        <i class="fal" [ngClass]="isLogisticsSearchLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                        <span>{{ isLogisticsSearchLoading ? 'Searching…' : 'Find prospects' }}</span>
                    </button>
                </div>
            </div>

        </section>

        @if (showLogisticsStickySearch && (!logisticsHasSearched || logisticsFiltersExpanded)) {
        <div class="logistics-scroll-controls">
            <aside class="logistics-active-criteria" aria-label="Active search criteria">
                <div class="logistics-active-criteria__heading">
                    <span>Active criteria</span>
                    <strong>{{ logisticsActiveFilterCount }}</strong>
                </div>
                @if (logisticsActiveFilterCount) {
                <search-parameters [inputParams]="{'searchTags': searchTags, 'enableClearing': true, 'logisticsMode': true}"
                    (onClearSearchParam)="clearSearchParam($event[0])"></search-parameters>
                } @else {
                <span class="logistics-active-criteria__empty">No filters selected</span>
                }
            </aside>
            <aside class="logistics-sticky-search" aria-label="Prospect search actions">
                <button type="button" class="logistics-primary-button" (click)="runLogisticsSearch()"
                    [disabled]="isLoading().loadingUI || isLogisticsSearchLoading || isReadOnlyUser">
                    <i class="fal" [ngClass]="isLogisticsSearchLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                    <span>{{ isLogisticsSearchLoading ? 'Searching…' : 'Find prospects' }}</span>
                </button>
            </aside>
        </div>
        }

        <div class="logistics-section-heading">
            <div>
                <span class="logistics-section-number">01</span>
                <div><span class="logistics-eyebrow">THE FOUNDATIONS</span><h2>Shape your ideal customer</h2></div>
            </div>
        </div>

        <div class="logistics-filter-stack" [class.loading-ui]="isLoading().loadingUI">
            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-bullseye-arrow"></i></span>
                    <span><strong>Ideal customer</strong><small>The products and services that create logistics demand</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-foundation-layout logistics-foundation-layout--ideal">
                        <section class="logistics-foundation-block logistics-foundation-block--concept">
                            <label for="logisticsProductSearch" class="form-label logistics-field-label"><i class="fal fa-box-open"></i> Products or services</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'products', label: 'Products or services' }"></ng-container>
                            @if (summarySemanticSearchTerm) {
                            <div class="logistics-product-term">
                                <span>{{ summarySemanticSearchTerm }}</span>
                                <button type="button" (click)="clearLogisticsProductTerm()"
                                    [attr.aria-label]="'Remove products or services filter: ' + summarySemanticSearchTerm">
                                    <i class="fal fa-xmark" aria-hidden="true"></i>
                                </button>
                            </div>
                            } @else {
                            <input #logisticsProductInput id="logisticsProductSearch" type="text"
                                [(ngModel)]="logisticsProductDraft" [ngModelOptions]="{standalone: true}"
                                placeholder="Describe a niche product or service"
                                (keydown.enter)="commitLogisticsProductTerm($event)" />
                            <small class="logistics-product-hint">Press Enter to add</small>
                            <div class="logistics-quick-picks" aria-label="Example product or service searches">
                                <span>Try:</span>
                                <button type="button" (click)="setLogisticsProductTerm('subscription dog food brands')">Subscription dog food brands</button>
                                <button type="button" (click)="setLogisticsProductTerm('cold-pressed juice producers')">Cold-pressed juice producers</button>
                                <button type="button" (click)="setLogisticsProductTerm('bespoke garden furniture retailers')">Bespoke garden furniture retailers</button>
                            </div>
                            }
                        </section>

                        <section class="logistics-foundation-block logistics-foundation-block--industries">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-industry-windows"></i></span>
                                <div><strong>Industries</strong><small>Browse or search official SIC classifications</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'industries', label: 'Industries' }"></ng-container>
                            </header>
                            <div class="logistics-segmented-control" aria-label="SIC selection type">
                                <button type="button" [class.active]="logisticsSicSelectionMode === 'include'"
                                    (click)="logisticsSicSelectionMode = 'include'">Include</button>
                                <button type="button" [class.active]="logisticsSicSelectionMode === 'exclude'"
                                    (click)="logisticsSicSelectionMode = 'exclude'">Exclude</button>
                            </div>
                            <div class="logistics-input-action logistics-input-action--quiet">
                                <input type="search" name="sicCodeTextSearch" [(ngModel)]="sicCodeTextSearch"
                                    (ngModelChange)="searchSicCodes()" placeholder="Search industries or SIC codes" />
                                <button type="button" (click)="resetSicSearch()" aria-label="Reset industry search">
                                    <i class="fal fa-undo"></i>
                                </button>
                            </div>
                            <div class="logistics-tree-list logistics-tree-list--sic">
                                <ng-container *ngFor="let sicCodeChoice of companySICCodeOptions">
                                    <div class="logistics-tree-row"
                                        *ngIf="(sicCodeChoice.type === 'section' && !isSearchingSicCodes) || sicCodeChoice.shouldShow">
                                        <label class="form-label" [style.padding-left.rem]="sicCodeChoice.level * 0.75">
                                            <input type="checkbox"
                                                [checked]="isLogisticsSicSelected(sicCodeChoice)"
                                                (change)="setLogisticsSicSelection(sicCodeChoice, $any($event.target).checked)" />
                                            <span><strong>{{ sicCodeChoice.identifier }}</strong> {{ sicCodeChoice.description }}</span>
                                        </label>
                                        <button *ngIf="sicCodeChoice.children?.length" type="button"
                                            (click)="expandOrCollapseSICCodes(sicCodeChoice.id)"
                                            [attr.aria-label]="'Expand ' + sicCodeChoice.description">
                                            <i class="fal fa-chevron-down"></i>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </section>

                        <section class="logistics-foundation-block logistics-foundation-block--contact">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-address-card"></i></span>
                                <div><strong>Contactable through</strong><small>Require a public company contact channel</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'contactChannels', label: 'Contactable through' }"></ng-container>
                            </header>
                            <div class="logistics-check-grid logistics-check-grid--contact">
                                <label class="form-label">
                                    <input type="checkbox" name="hasPhoneNumber" [(ngModel)]="hasPhoneNumber" />
                                    <span><i class="fal fa-phone"></i> Phone available</span>
                                </label>
                                <label class="form-label">
                                    <input type="checkbox" name="hasEmailAddress" [(ngModel)]="hasEmailAddress" />
                                    <span><i class="fal fa-envelope"></i> Email available</span>
                                </label>
                            </div>
                        </section>
                    </div>
                </div>
            </details>

            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-map-marker-alt"></i></span>
                    <span><strong>Geography</strong><small>Where they operate</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-foundation-layout logistics-foundation-layout--geography">
                        <section class="logistics-foundation-block logistics-foundation-block--coverage">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-map"></i></span>
                                <div><strong>Address coverage</strong><small>Choose which company locations should qualify</small></div>
                            </header>
                            <label for="logisticsAddressType" class="form-label logistics-field-label"><i class="fal fa-location-dot"></i> Match against</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'addressType', label: 'Match against' }"></ng-container>
                            <select id="logisticsAddressType" [(ngModel)]="selectedAddressTypeOption" name="selectedAddressTypeOption">
                                <option value="">Any known address</option>
                                <option *ngFor="let addressOption of addressOptions" [ngValue]="addressOption">{{ addressOption }}</option>
                            </select>

                            <label class="form-label logistics-field-label logistics-field-label--spaced"><i class="fal fa-map-location-dot"></i> UK regions</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'regions', label: 'UK regions' }"></ng-container>
                            <div class="logistics-option-list logistics-option-list--regions">
                                <label class="form-label" *ngFor="let region of ukRegions">
                                    <input type="checkbox" [attr.name]="'logisticsRegion' + region.name"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="region.checked"
                                        (change)="ukRegionChanged()" />
                                    <span>{{ region.name }}</span>
                                </label>
                            </div>
                        </section>

                        <section class="logistics-foundation-block logistics-foundation-block--proximity">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-location-crosshairs"></i></span>
                                <div><strong>Postcode targeting</strong><small>Choose the level of postcode precision</small></div>
                            </header>
                            <div class="logistics-segmented-control logistics-segmented-control--postcode">
                                <button type="button" [class.active]="logisticsPostcodeMode === 'prefix'"
                                    (click)="setLogisticsPostcodeMode('prefix')">Starts with</button>
                                <button type="button" [class.active]="logisticsPostcodeMode === 'district'"
                                    (click)="setLogisticsPostcodeMode('district')">District</button>
                                <button type="button" [class.active]="logisticsPostcodeMode === 'radius'"
                                    (click)="setLogisticsPostcodeMode('radius')">Nearby</button>
                            </div>
                            @if (logisticsPostcodeMode === 'prefix') {
                            <label for="logisticsPostcodePrefix" class="form-label logistics-field-label"><i class="fal fa-signs-post"></i> Postcode starts with</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'postcodePrefix', label: 'Postcode starts with' }"></ng-container>
                            <input id="logisticsPostcodePrefix" type="text" name="postcodeBeginsWith"
                                placeholder="e.g. EC2R 8" [(ngModel)]="postcodeBeginsWith"
                                (ngModelChange)="postcodeBeginsWithChanged()"
                                (keyup.enter)="testIfSearchCompaniesOnEnterPress($event)" />
                            }
                            @if (logisticsPostcodeMode === 'district') {
                            <label for="logisticsPostcodeDistrict" class="form-label logistics-field-label"><i class="fal fa-map-pin"></i> Postcode district</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'postcodeDistrict', label: 'Postcode district' }"></ng-container>
                            <input id="logisticsPostcodeDistrict" type="text" name="postcodeDistrict"
                                placeholder="e.g. EC2R" [(ngModel)]="postcodeDistrict"
                                (ngModelChange)="postcodeDistrictChanged()"
                                (keyup.enter)="testIfSearchCompaniesOnEnterPress($event)" />
                            }
                            @if (logisticsPostcodeMode === 'radius') {
                            <label for="logisticsPostcode" class="form-label logistics-field-label"><i class="fal fa-location-dot"></i> Near postcode</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'postcodeRadius', label: 'Near postcode' }"></ng-container>
                            <input id="logisticsPostcode" type="text" name="postcodeWithinRadius"
                                placeholder="e.g. SW1A 1AA" [(ngModel)]="postcodeWithinRadius"
                                (ngModelChange)="postcodeWithinRadiusChanged()"
                                (keyup.enter)="testIfSearchCompaniesOnEnterPress($event)" />
                            <div class="logistics-metric-control logistics-metric-control--proximity">
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'radiusMiles', label: 'Search radius' }"></ng-container>
                                <zint-ngx-slider #mileRadiusSliderElement *ngIf="mileRadiusRegisteredAddressRange"
                                    formName="Search radius" displayName="Search radius (miles)" [isRange]="false" postfix=" miles"
                                    [abbreviateInputValues]="true"
                                    [min]="mileRadiusRegisteredAddressRange.at(0)"
                                    [max]="mileRadiusRegisteredAddressRange.at(-1)"
                                    (sliderChange)="updatePostcodeMileageRange($event)"></zint-ngx-slider>
                            </div>
                            }
                        </section>
                    </div>
                </div>
            </details>

            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-ship"></i></span>
                    <span><strong>Trade activity</strong><small>Imports, exports and frequency</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <p class="logistics-trade-logic"><i class="fal fa-link"></i> Both conditions must match. Shipment cadence is measured across all traded products, not only the selected categories.</p>
                    <div class="logistics-control-groups logistics-control-groups--trade">
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-boxes-stacked"></i></span>
                                <div><strong>Trade profile</strong><small>Direction and products moved</small></div>
                            </header>
                            <label for="logisticsTradeDirection" class="form-label logistics-field-label"><i class="fal fa-arrow-right-arrow-left"></i> Has recently</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'tradeDirection', label: 'Has recently' }"></ng-container>
                            <select id="logisticsTradeDirection" [(ngModel)]="selectedImportingOrExportingOption"
                                name="selectedImportingOrExportingOption">
                                <option value="">Imported or exported</option>
                                <option *ngFor="let direction of importingExportingBothOptions" [ngValue]="direction.identifier">
                                    {{ direction.description_past }}
                                </option>
                            </select>

                            <label for="logisticsTradeSearch" class="form-label logistics-field-label logistics-field-label--spaced"><i class="fal fa-magnifying-glass"></i> Products traded</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'tradeProducts', label: 'Products traded' }"></ng-container>
                            <div class="logistics-input-action">
                                <input id="logisticsTradeSearch" type="search" name="importExportTextSearch"
                                    [(ngModel)]="importExportTextSearch" placeholder="Search commodity descriptions"
                                    (keyup.enter)="searchImportExportCodes()" />
                                <button type="button" (click)="searchImportExportCodes()" aria-label="Search trade products">
                                    <i class="fal fa-search"></i>
                                </button>
                            </div>
                            <button *ngIf="importExportTextSearch" type="button" class="logistics-inline-reset"
                                (click)="resetImportExportSearch()"><i class="fal fa-undo"></i> Show top-level categories</button>
                            <div class="logistics-tree-list logistics-tree-list--trade">
                                <ng-container *ngFor="let importExportCategory of importExportCategories">
                                    <div class="logistics-tree-row" *ngIf="importExportCategory.shouldShow">
                                        <label class="form-label" [style.padding-left.rem]="importExportCategory.level * 0.75">
                                            <input type="checkbox"
                                                [attr.name]="'logisticsImportExport' + importExportCategory.unique_identifier"
                                                [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="importExportCategory.checked"
                                                (change)="updateFilters(); updateToDefaultImportingOrExporting()" />
                                            <span>{{ importExportCategory.description }}</span>
                                        </label>
                                        <button type="button" (click)="expandOrCollapseImportExportCategories(importExportCategory)"
                                            [attr.aria-label]="'Expand ' + importExportCategory.description">
                                            <i class="fal" [ngClass]="importExportCategory.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="logistics-metric-control logistics-metric-control--trade-recency">
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'tradedWithin', label: 'Traded within' }"></ng-container>
                                <zint-ngx-slider #importExportSliderElement *ngIf="importExportMonthRange"
                                    formName="Traded within (months)" [isRange]="false" postfix=" months"
                                    [abbreviateInputValues]="true"
                                    [min]="importExportMonthRange[0]" [max]="importExportMonthRange[1]"
                                    (sliderChange)="updateImportExportTimeScale($event)"></zint-ngx-slider>
                            </div>
                        </section>

                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-calendar-clock"></i></span>
                                <div><strong>Overall shipment cadence</strong><small>Minimum activity across all products</small></div>
                            </header>
                            <label for="logisticsTradeFrequencyDirection" class="form-label logistics-field-label"><i class="fal fa-arrow-right-arrow-left"></i> Counted as</label>
                            <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'shipmentDirection', label: 'Counted as' }"></ng-container>
                            <select id="logisticsTradeFrequencyDirection"
                                [(ngModel)]="importExportFrequencyImportingOrExporting"
                                name="importExportFrequencyImportingOrExporting">
                                <option value="">Imports or exports</option>
                                <option *ngFor="let direction of importingExportingBothOptions" [ngValue]="direction.identifier">
                                    {{ direction.description_past }}
                                </option>
                            </select>
                            <div class="logistics-metric-grid logistics-metric-grid--trade">
                                <div class="logistics-metric-control">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'minimumShipments', label: 'Minimum shipments' }"></ng-container>
                                    <zint-ngx-slider #importExportFrequencySliderElement *ngIf="importExportFrequencyRange"
                                        formName="Minimum shipments" [isRange]="false" postfix=" times" maxPostfix="+"
                                        [abbreviateInputValues]="true"
                                        [min]="importExportFrequencyRange[0]" [max]="importExportFrequencyRange[1]"
                                        (sliderChange)="updateImportExportFrequency($event)"></zint-ngx-slider>
                                </div>
                                <div class="logistics-metric-control">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'shipmentPeriod', label: 'Shipment period' }"></ng-container>
                                    <zint-ngx-slider #importExportFrequencyMonthCountSliderElement
                                        *ngIf="importExportFrequencyMonthCountRange" formName="Frequency period" displayName="Frequency period (months)"
                                        [isRange]="false" postfix=" months"
                                        [abbreviateInputValues]="true"
                                        [min]="importExportFrequencyMonthCountRange[0]"
                                        [max]="importExportFrequencyMonthCountRange[1]"
                                        (sliderChange)="updateImportExportFrequencyMonthCount($event)"></zint-ngx-slider>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </details>

            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-chart-line"></i></span>
                    <span><strong>Scale &amp; momentum</strong><small>Commercial size and growth</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-control-groups logistics-control-groups--scale">
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-users"></i></span>
                                <div><strong>Team size</strong><small>Current workforce and hiring momentum</small></div>
                            </header>
                            <div class="logistics-metric-grid">
                                <div class="logistics-metric-control">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'companyAge', label: 'Company age' }"></ng-container>
                                    <zint-ngx-slider #companyAgeSliderElement *ngIf="companyAgeRange"
                                        formName="Company age" displayName="Company age (years)" postfix=" years" maxPostfix="+"
                                        [min]="companyAgeRange.at(0)" [max]="companyAgeRange.at(-1)"
                                        [abbreviateInputValues]="true"
                                        (sliderChange)="updateCompanyAgeRange($event)"></zint-ngx-slider>
                                </div>
                                <div class="logistics-metric-control">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'headcount', label: 'Headcount' }"></ng-container>
                                    <zint-ngx-slider #headcountSliderElement *ngIf="employeeRangeFigures" formName="Headcount"
                                        postfix=" employees" maxPostfix="+" [min]="employeeRangeFigures.at(0)"
                                        [abbreviateInputValues]="true"
                                        [max]="employeeRangeFigures.at(-1)"
                                        (sliderChange)="updateEmployeeRange($event)"></zint-ngx-slider>
                                </div>
                                <div class="logistics-metric-control">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'headcountGrowth', label: 'Headcount growth' }"></ng-container>
                                    <zint-ngx-slider #headcountGrowthSliderElement *ngIf="headcountGrowthPercentageRange"
                                        formName="Headcount growth" displayName="Headcount growth (%)" postfix="%" [min]="headcountGrowthPercentageRange.at(0)"
                                        [abbreviateInputValues]="true"
                                        [max]="headcountGrowthPercentageRange.at(-1)"
                                        (sliderChange)="updateHeadcountGrowthRange($event)"></zint-ngx-slider>
                                </div>
                            </div>
                        </section>
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-chart-line-up"></i></span>
                                <div><strong>Financial profile</strong><small>Scale, growth and stockholding</small></div>
                            </header>
                            <div class="logistics-metric-grid">
                                <div class="logistics-metric-control" *ngFor="let slider of logisticsFinancialSliders">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: slider.label, label: slider.label }"></ng-container>
                                    <zint-ngx-slider #genericConfigSliders [sliderConfig]="getLogisticsSliderConfig(slider)" [displayName]="getLogisticsSliderDisplayName(slider)" [abbreviateInputValues]="true"
                                        (sliderChange)="triggerConfigSliderUpdate($event, slider.label)"></zint-ngx-slider>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </details>

            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-warehouse"></i></span>
                    <span><strong>Operations</strong><small>Technology, teams and vehicle investment</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-control-groups">
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-laptop-code"></i></span>
                                <div><strong>Technology</strong><small>Logistics and e-commerce tools</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'technology', label: 'Technology' }"></ng-container>
                            </header>
                            <div class="logistics-input-action logistics-input-action--quiet">
                                <input type="search" name="logisticsWebTechnologySearch"
                                    [(ngModel)]="logisticsWebTechnologySearch"
                                    (ngModelChange)="searchLogisticsWebTechnologies()"
                                    placeholder="Search logistics technologies" />
                                <button type="button" (click)="resetLogisticsWebTechnologySearch()"
                                    aria-label="Reset technology search"><i class="fal fa-undo"></i></button>
                            </div>
                            <div class="logistics-tree-list logistics-tree-list--technology">
                                <ng-container *ngFor="let technology of logisticsWebTechnologyOptions">
                                    <div class="logistics-tree-row" *ngIf="technology.shouldShow">
                                        <label class="form-label" [style.padding-left.rem]="technology.level * 0.75">
                                            <input type="checkbox" [attr.name]="'logisticsTechnology' + technology.name"
                                                [ngModelOptions]="{standalone: true}" [(ngModel)]="technology.checked" />
                                            <span>{{ technology.description }}</span>
                                        </label>
                                        <button *ngIf="technology.children?.length" type="button"
                                            (click)="toggleLogisticsWebTechnologyCategory(technology)"
                                            [attr.aria-label]="'Expand ' + technology.description">
                                            <i class="fal" [ngClass]="isLogisticsWebTechnologyExpanded(technology) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            @if (logisticsWebTechnologySearch.trim().length >= 2 && !hasLogisticsWebTechnologyMatches) {
                            <p class="logistics-empty-note">No matching technology in this list.</p>
                            }
                        </section>
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-people-group"></i></span>
                                <div><strong>Operational teams</strong><small>Functions and department capacity</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'departments', label: 'Operational teams' }"></ng-container>
                            </header>
                            <div class="logistics-option-list logistics-option-list--compact">
                                <label class="form-label" *ngFor="let department of logisticsFunctionalDepartmentOptions">
                                    <input type="checkbox" [attr.name]="'logisticsDepartment' + department.name"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="department.checked" />
                                    {{ department.name }}
                                </label>
                            </div>
                            <div class="logistics-metric-control logistics-metric-control--standalone">
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'departmentHeadcount', label: 'Department headcount' }"></ng-container>
                                <zint-ngx-slider #departmentHeadcountSliderElement *ngIf="employeeRangeFigures"
                                    formName="Department headcount" postfix=" employees" maxPostfix="+"
                                    [abbreviateInputValues]="true"
                                    [min]="employeeRangeFigures.at(0)" [max]="employeeRangeFigures.at(-1)"
                                    (sliderChange)="updateDepartmentHeadcountRange($event)"></zint-ngx-slider>
                            </div>
                        </section>
                        <section class="logistics-control-group logistics-control-group--wide">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-truck"></i></span>
                                <div><strong>Fleet investment</strong><small>Vehicles, trailers and tangible assets</small></div>
                            </header>
                            <div class="logistics-metric-grid logistics-metric-grid--assets">
                                <div class="logistics-metric-control" *ngFor="let slider of logisticsAssetSliders">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: slider.label, label: slider.label }"></ng-container>
                                    <zint-ngx-slider #genericConfigSliders [sliderConfig]="getLogisticsSliderConfig(slider)" [displayName]="getLogisticsSliderDisplayName(slider)" [abbreviateInputValues]="true"
                                        (sliderChange)="triggerConfigSliderUpdate($event, slider.label)"></zint-ngx-slider>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </details>

            <details class="logistics-filter-card">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-bolt"></i></span>
                    <span><strong>News &amp; trigger events</strong><small>Recent events that may create logistics demand</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-control-groups logistics-control-groups--opportunity">
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-newspaper"></i></span>
                                <div><strong>Event types</strong><small>Choose the company developments that matter</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'newsEvents', label: 'Event types' }"></ng-container>
                            </header>
                            <div class="logistics-news-groups">
                                <details *ngFor="let newsGroup of logisticsNewsEventGroups">
                                    <summary>
                                        <span><strong>{{ newsGroup.label }}</strong><small>{{ newsGroup.description }}</small></span>
                                        <i class="fal fa-chevron-down"></i>
                                    </summary>
                                    <div class="logistics-option-list logistics-option-list--plain">
                                        <label class="form-label" *ngFor="let newsOption of newsGroup.options">
                                            <input type="checkbox"
                                                [attr.name]="'logisticsNews' + newsOption.label"
                                                [checked]="isLogisticsNewsOptionSelected(newsOption.categoryNames)"
                                                (change)="setLogisticsNewsOption(newsOption.categoryNames, $any($event.target).checked)" />
                                            {{ newsOption.label }}
                                        </label>
                                    </div>
                                </details>
                            </div>
                        </section>
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-clock"></i></span>
                                <div><strong>Recency</strong><small>How recent the signal should be</small></div>
                            </header>
                            <div class="logistics-metric-control logistics-metric-control--standalone">
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'newsRecency', label: 'News recency' }"></ng-container>
                                <zint-ngx-slider #newsDayRangeSliderElement *ngIf="newsDaysRange" formName="News published within" displayName="News published within (days)"
                                    [isRange]="false" postfix=" days" [min]="newsDaysRange.at(0)" [max]="newsDaysRange.at(-1)"
                                    [abbreviateInputValues]="true"
                                    (sliderChange)="updateNewsDays($event)"></zint-ngx-slider>
                            </div>
                        </section>
                    </div>
                </div>
            </details>

        </div>

        <section class="logistics-intelligence">
            <div class="logistics-section-heading logistics-section-heading--intelligence">
                <div>
                    <span class="logistics-section-number">02</span>
                    <div><span class="logistics-eyebrow">MAGIC INSIGHTS</span><h2>Qualify the operational opportunity</h2></div>
                </div>
                <p class="logistics-ai-disclaimer"><i class="fal fa-wand-sparkles"></i> AI-generated estimates based on available company information. Treat them as directional and verify important details.</p>
            </div>

            <nav class="logistics-service-nav" aria-label="Logistics service areas">
                @for (section of logisticsMagicInsightSections; track section.id) {
                <button type="button" [class.active]="section.id === activeLogisticsServiceSection"
                    (click)="setActiveLogisticsServiceSection(section.id)">
                    <i class="fal {{ section.icon }}"></i>
                    <span><strong>{{ section.title }}</strong><small>{{ section.filterCount || section.expectedFilterCount }} {{ (section.filterCount || section.expectedFilterCount) === 1 ? 'filter' : 'filters' }}</small></span>
                </button>
                }
            </nav>

            <!-- Keep every section's controls mounted and hide the inactive ones, so a
                 saved or shared search can restore Magic Insights sliders outside the open tab. -->
            @for (section of logisticsMagicInsightSections; track section.id) {
            <div class="logistics-intelligence-panel" [hidden]="section !== activeLogisticsMagicInsightSection">
                <header>
                    <span class="logistics-intelligence-panel__icon"><i class="fal {{ section.icon }}"></i></span>
                    <div>
                        <span class="logistics-eyebrow">{{ section.eyebrow }}</span>
                        <h3>{{ section.title }}</h3>
                        <p>{{ section.description }}</p>
                    </div>
                    <span class="logistics-filter-count">{{ section.filterCount }}/{{ section.expectedFilterCount }} available</span>
                </header>

                @if (isLoading().loadingMagicFilters) {
                <div class="logistics-intelligence-state">
                    <i class="fa-solid fa-wand-sparkles fa-flip"></i>
                    <strong>Loading logistics intelligence…</strong>
                </div>
                } @else if (!section.groups.length) {
                <div class="logistics-intelligence-state logistics-intelligence-state--empty">
                    <span><i class="fal fa-lock"></i></span>
                    <div><strong>This intelligence set is not available on the current account.</strong>
                    <p>The workspace preserves all {{ section.expectedFilterCount }} controls here when the corresponding production module is entitled.</p></div>
                </div>
                } @else {
                <div class="logistics-intelligence-grid">
                    @for (group of section.groups; track group.moduleName + group.questionId + group.groupKey) {
                    <article class="logistics-intelligence-card" [class.is-locked]="!group.hasFilterAccess">
                        <header>
                            <div><h4>{{ group.questionTitle }}</h4></div>
                            @if (!group.hasFilterAccess) {
                            <i class="fal fa-lock" matTooltip="Upgrade the current plan to use these filters"></i>
                            }
                        </header>
                        @if (group.questionReference === 204) {
                        <p class="logistics-linked-note"><i class="fal fa-link"></i> Choose a country and its shipment share together</p>
                        } @else if (group.questionReference === 290) {
                        <p class="logistics-linked-note"><i class="fal fa-link"></i> Choose a transport mode and its share together</p>
                        }
                        <div class="logistics-intelligence-card__fields">
                            @for (filter of group.filters; track filter.label) {
                            @if (filter.filterType === 'range_slider') {
                            <div class="logistics-magic-field">
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: filter.fieldName, label: filter.label }"></ng-container>
                                <zint-ngx-slider #genericConfigSliders
                                    [sliderConfig]="getLogisticsSliderConfig(filter)" [displayName]="logisticsMagicFieldDisplayName(filter.fieldName, getLogisticsSliderDisplayName(filter))"
                                    [abbreviateInputValues]="true"
                                    (sliderChange)="triggerConfigSliderWithObjectUpdate($event, filter)"></zint-ngx-slider>
                                <details class="logistics-confidence">
                                    <summary><i class="fal fa-gauge-high"></i> Confidence</summary>
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'confidence', label: 'Confidence' }"></ng-container>
                                    <zint-ngx-slider #confidenceSliders
                                        [formName]="'confidence:' + filter.label + 'Aira' + filter.airaQuestionId" displayName="Confidence (%)"
                                        [min]="0" [max]="100" postfix="%"
                                        (sliderChange)="triggerConfidenceSliderUpdate($event, filter)"></zint-ngx-slider>
                                </details>
                            </div>
                            }
                            @if (filter.filterType === 'text_input') {
                            <div class="logistics-magic-field">
                                <label class="form-label">{{ logisticsMagicFieldDisplayName(filter.fieldName, filter.label) }}</label>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: filter.fieldName, label: filter.label }"></ng-container>
                                <input type="text" [name]="'logisticsMagic' + filter.airaQuestionId + filter.fieldName"
                                    [(ngModel)]="filter.value"
                                    (change)="triggerConfigTextInputWithObjectUpdate(filter.value, filter)"
                                    placeholder="Type a word or phrase" />
                                <details class="logistics-confidence">
                                    <summary><i class="fal fa-gauge-high"></i> Confidence</summary>
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'confidence', label: 'Confidence' }"></ng-container>
                                    <zint-ngx-slider #confidenceSliders
                                        [formName]="'confidence:' + filter.label + 'Aira' + filter.airaQuestionId" displayName="Confidence (%)"
                                        [min]="0" [max]="100" postfix="%"
                                        (sliderChange)="triggerConfidenceSliderUpdate($event, filter)"></zint-ngx-slider>
                                </details>
                            </div>
                            }
                            @if (filter.filterType === 'multi_select') {
                            <div class="logistics-magic-field">
                                <label class="form-label">{{ logisticsMagicFieldDisplayName(filter.fieldName, filter.label) }}</label>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: filter.fieldName, label: filter.label }"></ng-container>
                                @if (filter.options_type === 'countries_and_territories') {
                                <div class="logistics-input-with-icon">
                                    <i class="fal fa-search"></i>
                                    <input type="search" placeholder="Find a country"
                                        [name]="'logisticsMagicCountry' + filter.airaQuestionId + filter.fieldName"
                                        (input)="filterMagicCountriesList($event.target.value, group.moduleName, filter.linkedFieldName || filter.fieldName)" />
                                </div>
                                }
                                <div class="logistics-magic-options">
                                    @for (optionElement of filter.options; track optionElement.value) {
                                    <label class="form-label" *ngIf="filter.options_type ? optionElement.shouldShow : true">
                                        <input type="checkbox" [name]="'logisticsMagicOption' + filter.airaQuestionId + filter.fieldName + optionElement.value"
                                            [(ngModel)]="optionElement.checked"
                                            (ngModelChange)="triggerConfigMultiSelectInputWithObjectUpdate(filter)" />
                                        <span>{{ optionElement.name || optionElement.label }}</span>
                                    </label>
                                    }
                                </div>
                                <details class="logistics-confidence">
                                    <summary><i class="fal fa-gauge-high"></i> Confidence</summary>
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'confidence', label: 'Confidence' }"></ng-container>
                                    <zint-ngx-slider #confidenceSliders
                                        [formName]="'confidence:' + filter.label + 'Aira' + filter.airaQuestionId" displayName="Confidence (%)"
                                        [min]="0" [max]="100" postfix="%"
                                        (sliderChange)="triggerConfidenceSliderUpdate($event, filter)"></zint-ngx-slider>
                                </details>
                            </div>
                            }
                            }
                        </div>
                    </article>
                    }
                </div>
                }
            </div>
            }
        </section>

        <section class="logistics-zint-section" aria-labelledby="logistics-zint-heading">
            <div class="logistics-section-heading">
                <div>
                    <span class="logistics-section-number">03</span>
                    <div><span class="logistics-eyebrow">YOUR WORKSPACE</span><h2 id="logistics-zint-heading">Your Zint</h2></div>
                </div>
            </div>
            @if (availableTerritories?.length) {
            <section class="logistics-search-scope" aria-label="Search scope">
                <span class="logistics-search-scope__icon"><i class="fal fa-globe-europe"></i></span>
                <div>
                    <strong>Territory</strong>
                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'territory', label: 'Territory' }"></ng-container>
                    <small>Use one of your organisation's prospect territories</small>
                </div>
                <select name="selectedTerritory" [(ngModel)]="selectedTerritory"
                    [compareWith]="compareTerritories" aria-label="Selected territory">
                    <option *ngIf="!areTerritoriesEnforced" [ngValue]="null">All permitted companies</option>
                    <option *ngFor="let territory of availableTerritories" [ngValue]="territory">
                        {{ territory.name }}
                    </option>
                </select>
                @if (areTerritoriesEnforced) {
                <span class="logistics-search-scope__locked"><i class="fal fa-lock"></i> Enforced by your organisation</span>
                }
            </section>
            }
            <details class="logistics-filter-card logistics-zint-filters">
                <summary>
                    <span class="logistics-filter-card__icon"><i class="fal fa-layer-group"></i></span>
                    <span><strong>Workspace filters</strong><small>Your fields and team activity</small></span>
                    <i class="fal fa-chevron-down logistics-filter-card__chevron"></i>
                </summary>
                <div class="logistics-filter-card__body">
                    <div class="logistics-control-groups logistics-control-groups--workspace-data">
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-table-columns"></i></span>
                                <div><strong>Your workspace fields</strong><small>Filter using data your organisation has added to Zint</small></div>
                                <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'workspaceFields', label: 'Your workspace fields' }"></ng-container>
                            </header>
                            <div class="logistics-input-action logistics-input-action--quiet">
                                <input type="search" name="customColumnSearchTerm" minlength="2" maxlength="32"
                                    placeholder="Find one of your fields" [(ngModel)]="customColumnSearchTerm"
                                    (ngModelChange)="filterCustomColumns()" />
                                <button type="button" (click)="customColumnSearchTerm = ''; filterCustomColumns()"
                                    aria-label="Reset workspace field search"><i class="fal fa-undo"></i></button>
                            </div>
                            @if (filteredCustomColumns?.length) {
                            <div class="logistics-custom-fields">
                                <custom-column-filter
                                    [inputParams]="{'customColumns': filteredCustomColumns, 'filterOnAttribute': 'is_basic_column', 'equalsOrNot': true, 'teamMembers': teamMembersForCustomColumns, 'logisticsMode': true}"></custom-column-filter>
                            </div>
                            } @else {
                            <p class="logistics-empty-note">No matching workspace fields.</p>
                            }
                        </section>
                        <section class="logistics-control-group">
                            <header class="logistics-control-group__header">
                                <span><i class="fal fa-pepper-hot"></i></span>
                                <div><strong>Team engagement</strong><small>Find companies by their recent Zint Heat Score</small></div>
                            </header>
                            <div class="logistics-metric-control">
                                <ng-container *ngFor="let slider of zintSlidersConfigs['heatScore']">
                                    <ng-container *ngTemplateOutlet="filterHelp; context: { key: 'heatScore', label: 'Team engagement' }"></ng-container>
                                    <zint-ngx-slider #heatScoreSliders [sliderConfig]="getLogisticsSliderConfig(slider)" [displayName]="getLogisticsSliderDisplayName(slider)"
                                        (sliderChange)="triggerConfigSliderUpdate($event, slider.label)"></zint-ngx-slider>
                                </ng-container>
                            </div>
                            <p class="logistics-help-text"><i class="fal fa-circle-info"></i> Heat Score reflects activity from your team over the last 30 days.</p>
                        </section>
                    </div>
                </div>
            </details>
        </section>

    </section>

        @if (logisticsHasSearched) {
        <mat-drawer-container autosize [hasBackdrop]="logisticsHasSearched"
            [attr.inert]="logisticsFilterDrawerOpen ? '' : null">

            <mat-drawer-content>
            <div class="main-grid">

                <div class="logistics-results-intro" aria-label="Search results section">
                    <span class="logistics-results-intro__mark" aria-hidden="true"><i class="fal fa-building"></i></span>
                    <div><span class="logistics-eyebrow">YOUR PROSPECTS</span><h2>Search results</h2></div>
                </div>

                <!-- reset and search params tags box -->
                @if (searchTags && searchTags.length > 0) {
                    <div class="card mb-2 logistics-search-summary" style="border-radius: 8px">
                        <div class="card-body search-actions-container">
                            <div class="logistics-search-summary__actions">
                                <button type="button" class="logistics-reset-button" (click)="editLogisticsFilters()">
                                    <i class="fal fa-sliders-simple me-1"></i>Refine search
                                </button>
                                <button type="button" class="logistics-reset-button logistics-reset-button--quiet" (click)="resetLogisticsFilters()">
                                    <i class="fal fa-undo me-1"></i>Clear all
                                </button>
                            </div>
                            <search-parameters [inputParams]="{'searchTags': searchTags, 'enableClearing': true, 'logisticsMode': true}"
                                [savedSearchName]="savedSearchParamName"
                                (onClearSearchParam)="clearSearchParam($event[0])"></search-parameters>
                        </div>
                    </div>
                }


                <section id="logistics-results-section" class="logistics-results" [class.is-searching]="isLogisticsSearchLoading" aria-labelledby="logisticsResultsHeading">
                    <header class="logistics-results__header">
                        <div>
                            <span class="logistics-eyebrow">MATCHING COMPANIES</span>
                            <h2 id="logisticsResultsHeading">
                                @if (isLogisticsSearchLoading) {
                                Finding your prospects…
                                } @else {
                                <span *ngIf="!companyCount().exact">About </span>{{ companyCount().count | number }}
                                <span *ngIf="companyCount().active_only"> active</span> companies match
                                }
                            </h2>
                            @if (logisticsHasPendingChanges) {
                            <p class="logistics-results-pending"><i class="fal fa-circle-info"></i> Filters have changed. These results reflect your last search.</p>
                            }
                        </div>
                        <div class="logistics-results__header-actions">
                            @if (logisticsFiltersCollapsed) {
                            <button #logisticsRestoreFiltersButton type="button" class="logistics-secondary-button logistics-restore-filters"
                                aria-controls="search-area" aria-expanded="false" (click)="restoreLogisticsFilters()">
                                <i class="fal fa-chevron-right" aria-hidden="true"></i><span>Show filters</span>
                            </button>
                            }
                            @if (!isLogisticsSearchLoading) {
                            <button type="button" class="logistics-secondary-button" (click)="openResultsActionModal('saveSearch')">
                                <i class="fal fa-bookmark"></i><span>Save search</span>
                            </button>
                            }
                            <button #logisticsRefineButton type="button" class="logistics-secondary-button" (click)="editLogisticsFilters()">
                                <i class="fal fa-sliders-simple"></i><span>Refine search</span>
                            </button>
                        </div>
                    </header>

                    @if (isLogisticsSearchLoading) {
                    <div class="logistics-search-loading" role="status" aria-live="polite">
                        <div class="logistics-search-loading__visual" aria-hidden="true">
                            <span class="logistics-search-loading__ring"></span>
                            <span class="logistics-search-loading__ring logistics-search-loading__ring--second"></span>
                            <span class="logistics-search-loading__icon"><i class="fal fa-truck-fast"></i></span>
                        </div>
                        <div class="logistics-search-loading__copy">
                            <span class="logistics-eyebrow">SEARCH IN PROGRESS</span>
                            <h3>Finding the right companies</h3>
                            <p>Checking your criteria against company data.</p>
                            @if (logisticsSearchElapsedSeconds >= 5) {
                            <small>Still working · {{ logisticsSearchElapsedSeconds }}s elapsed</small>
                            }
                        </div>
                        <div class="logistics-search-loading__progress" aria-hidden="true"><span></span></div>
                    </div>
                    }

                    @if (!isLogisticsSearchLoading) {
                    <div class="logistics-results-perspective" aria-label="Choose which logistics signals the company cards prioritise">
                        <div class="logistics-results-perspective__intro">
                            <span>Card view</span>
                            <small>Reorders the insights shown. Your search stays the same.</small>
                        </div>
                        <div class="logistics-results-perspective__options" role="group" aria-label="Logistics operative mode">
                            @for (perspective of logisticsResultsPerspectives; track perspective.id) {
                            <button type="button"
                                [class.is-active]="logisticsResultsPerspective === perspective.id"
                                [attr.aria-pressed]="logisticsResultsPerspective === perspective.id"
                                [matTooltip]="perspective.description"
                                matTooltipClass="logistics-action-tooltip"
                                (click)="setLogisticsResultsPerspective(perspective.id)">
                                <i class="fal {{ perspective.icon }}"></i>
                                <span class="logistics-results-perspective__full-label">{{ perspective.label }}</span>
                                <span class="logistics-results-perspective__short-label">{{ perspective.shortLabel }}</span>
                            </button>
                            }
                        </div>
                    </div>

                    <div class="logistics-results-toolbar">
                        <div class="logistics-results-toolbar__selection">
                            <label class="form-label logistics-select-page">
                                <input type="checkbox" name="logisticsSelectAllCompanies"
                                    [disabled]="isLoading().loadingCompanies"
                                    [indeterminate]="isPageSelectionIndeterminate"
                                    [(ngModel)]="checkboxSelectAllCompanies"
                                    (ngModelChange)="showOrHideInfoOnAllSelectedCompanies()" />
                                <span>Select this page</span>
                            </label>
                            @if (totalCompaniesSelected) {
                            <span class="logistics-selection-count" aria-live="polite">{{ totalCompaniesSelected | number }} of {{ selectableCompanyCount | number }} selected</span>
                            <label class="form-label logistics-selection-amount" for="logisticsSelectionAmount">Select first
                                <input id="logisticsSelectionAmount" name="logisticsSelectionAmount" type="number"
                                    min="1" step="1" [max]="selectableCompanyCount" [(ngModel)]="selectionAmount"
                                    aria-label="Number of companies to select" placeholder="Count"
                                    (ngModelChange)="selectionAmountEdited = true"
                                    [attr.aria-invalid]="!!selectionAmountError"
                                    [attr.aria-describedby]="selectionAmountError ? 'logisticsSelectionAmountError' : null"
                                    (keydown.enter)="$event.preventDefault(); applySelectionAmount()" />
                            </label>
                            <button type="button" class="logistics-secondary-button" [disabled]="!canApplySelection"
                                (click)="applySelectionAmount()">Apply</button>
                            @if (selectionAmountError) {
                            <small id="logisticsSelectionAmountError" class="text-danger" role="status">{{ selectionAmountError }}</small>
                            }
                            @if (selectableCompanyCount !== totalCompaniesSelected) {
                            <button type="button" class="logistics-text-button" (click)="hasSelectedAllCompaniesByQuery()">
                                Select all
                            </button>
                            }
                            <button type="button" class="logistics-text-button" (click)="clearDashboardSelection()">Clear</button>
                            }
                        </div>

                        @if (totalCompaniesSelected) {
                        <div class="logistics-bulk-actions" aria-label="Actions for selected companies">
                            <button type="button" (click)="openSelectionModal('dashboardTagModal')" matTooltip="Tag or untag selected companies" matTooltipClass="logistics-action-tooltip">
                                <i class="fal fa-tag"></i><span>Tag</span>
                            </button>
                            <button type="button" (click)="toggleDownloadModal()" matTooltip="Download selected companies" matTooltipClass="logistics-action-tooltip">
                                <i class="fal fa-download"></i><span>Download</span>
                            </button>
                            @for (crm of availableCRMList; track $index) {
                                @if (crm.functionalityEnabled) {
                                <button type="button" (click)="openCRMExportModal(crm.name)" matTooltip="Export selected companies to {{ crm.name }}" matTooltipClass="logistics-action-tooltip">
                                    <span [innerHTML]="getCRMIcon(crm.crmType)"></span><span>{{ crm.name }}</span>
                                </button>
                                }
                            }
                            <button type="button" (click)="openSelectionModal('customColumnEditModal')" matTooltip="Bulk edit attributes" matTooltipClass="logistics-action-tooltip">
                                <i class="fal fa-pen-field"></i><span>Attributes</span>
                            </button>
                            @if (hasAIRAAccess) {
                            <button type="button" (click)="openGetInsights()" matTooltip="Get Magic Insights for selected companies" matTooltipClass="logistics-action-tooltip">
                                <i class="fal fa-wand-sparkles"></i><span>Get insights</span>
                            </button>
                            }
                        </div>
                        }

                        <div class="logistics-results-toolbar__controls">
                            <label class="form-label">
                                <span>Sort</span>
                                <select name="logisticsResultSort" [ngModel]="sortKey || ''"
                                    (ngModelChange)="updateLogisticsSortKey($event)">
                                    <option value="">Default order</option>
                                    @if (summarySemanticSearchTerm) {
                                    <option [value]="semanticSearchScoreSortKey">Best product match</option>
                                    }
                                    @for (field of getLogisticsSortableFields(); track field) {
                                        @if (field !== semanticSearchScoreSortKey) {
                                        <option [value]="field">{{ field }}</option>
                                        }
                                    }
                                </select>
                            </label>
                            <button type="button" class="logistics-sort-direction" (click)="toggleLogisticsSortDirection()"
                                [disabled]="!sortKey" [attr.aria-label]="sortDirectionIsAscending ? 'Sort descending' : 'Sort ascending'">
                                <i class="fal" [ngClass]="sortDirectionIsAscending ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                            </button>
                            <label class="form-label">
                                <span>Per page</span>
                                <select name="logisticsPageSize" [ngModel]="selectedPageSizeLimit"
                                    (ngModelChange)="updateLogisticsPageSize($event)">
                                    @for (limit of [10,25,50,100]; track limit) {
                                    <option [ngValue]="limit" [disabled]="limit > maxPageSizeLimit">{{ limit }}</option>
                                    }
                                </select>
                            </label>
                        </div>
                    </div>
                    }

                    @if (isLogisticsSearchLoading) {
                    <div class="logistics-results-list" aria-label="Loading companies">
                        @for (placeholder of [1, 2, 3]; track placeholder) {
                        <article class="logistics-company-card logistics-company-card--loading" aria-hidden="true">
                            <div class="logistics-company-card--loading__header">
                                <span class="logistics-company-card--loading__logo"></span>
                                <div><span class="logistics-company-card--loading__name"></span><span class="logistics-company-card--loading__number"></span></div>
                                <span class="logistics-company-card--loading__action"></span>
                            </div>
                            <div class="logistics-company-card--loading__fields"><span></span><span></span><span></span></div>
                        </article>
                        }
                    </div>
                    } @else if (companies?.length) {
                    <div class="logistics-results-list">
                        @for (company of companies; track company.id) {
                        <article class="logistics-company-card" [class.is-selected]="company.checked">
                            <header class="logistics-company-card__header">
                                <label class="form-label logistics-company-card__select" matTooltip="Select this company">
                                    <input type="checkbox" name="logisticsCompanySelectedOption{{ company.id }}"
                                        [disabled]="isLoading().loadingCompanies"
                                        (change)="updateCountOfSelectedCompanies()" [(ngModel)]="company.checked" />
                                    <span class="visually-hidden">Select {{ company['Company Name'] }}</span>
                                </label>
                                <span class="logistics-company-card__monogram" aria-hidden="true">
                                    @if (getLogisticsWebsiteHref(company) && !company.logisticsLogoFailed) {
                                    <img [src]="'https://www.google.com/s2/favicons?sz=64&domain=' + getLogisticsWebsiteLabel(company)"
                                        alt="" (error)="company.logisticsLogoFailed = true" />
                                    } @else {
                                    {{ company['Company Name']?.charAt(0) || 'C' }}
                                    }
                                </span>
                                <div class="logistics-company-card__identity">
                                    <div class="logistics-company-card__name">
                                        <a [href]="'/profile/' + company.number + '/logistics'" target="_blank">{{ company['Company Name'] }}</a>
                                    </div>
                                    <span>
                                        Company no. {{ company.number }}
                                        @if (getLogisticsWebsiteHref(company)) {
                                        <span class="logistics-company-card__identity-separator">·</span>
                                        <a class="logistics-company-card__website" [href]="getLogisticsWebsiteHref(company)"
                                            target="_blank" rel="noopener">
                                            <i class="fal fa-globe"></i>{{ getLogisticsWebsiteLabel(company) }}
                                        </a>
                                        }
                                    </span>
                                </div>
                                <div class="logistics-company-card__badges">
                                    @if (company.hasMIAvailable === MIAvailabilityStatus.hasMI) {
                                    <span class="logistics-result-badge logistics-result-badge--insight"><i class="far fa-sparkle"></i> Insights available</span>
                                    }
                                    @if (company.hasViewed) {
                                    <span class="logistics-result-badge"><i class="fal fa-eye"></i> Viewed</span>
                                    }
                                </div>
                                <div class="logistics-company-card__actions">
                                    @if (!isScreenTooSmall()) {
                                    <button type="button" (click)="toggleProfilePreview(company.number)">
                                        <i class="fal fa-window-maximize"></i><span>Preview</span>
                                    </button>
                                    }
                                    <a [href]="'/profile/' + company.number + '/logistics'" target="_blank">
                                        <span>View company</span><i class="fal fa-arrow-up-right-from-square"></i>
                                    </a>
                                </div>
                            </header>

                            @if (getLogisticsAvailableInsightCount(company)) {
                            <div class="logistics-company-card__match">
                                <span><i class="fal fa-wand-sparkles"></i> Magic Insights</span>
                                <strong>
                                    @if (getLogisticsAvailableInsightCount(company) === getLogisticsVisibleInsightCount(company)) {
                                    {{ getLogisticsAvailableInsightCount(company) }} available for this company
                                    } @else {
                                    {{ getLogisticsVisibleInsightCount(company) }} displayed · {{ getLogisticsAvailableInsightCount(company) }} available for this company
                                    }
                                </strong>
                            </div>
                            }

                            <dl class="logistics-company-card__fields">
                                @for (field of getLogisticsCoreFields(company); track field.key) {
                                <div>
                                    <dt><i class="fal {{ field.icon }}"></i> {{ field.label }}</dt>
                                    <dd>
                                        @if (hasLogisticsResultValue(field.val)) {
                                        <span [innerHtml]="field.val | companyDataPipe:field.key:company.number:accountsSearchTerm:homepageSearchTerm:fullWebsiteSearchTerm:newsContaining"></span>
                                        } @else {
                                        <span class="logistics-result-empty" title="Not reported">—</span>
                                        }
                                    </dd>
                                </div>
                                }
                            </dl>

                            @if (getLogisticsProductsAndServices(company).length) {
                            <div class="logistics-company-card__products">
                                <span><i class="fal fa-box-open"></i> Products &amp; services</span>
                                <div>
                                    @for (productOrService of getLogisticsProductsAndServices(company); track productOrService) {
                                    <span>{{ productOrService }}</span>
                                    }
                                </div>
                            </div>
                            }

                            @if (getLogisticsAvailableInsightCount(company)) {
                            <div class="logistics-company-card__insights">
                                @for (panel of getLogisticsCardPanels(company); track panel.priorityKey) {
                                @if (panel.panelType === 'provider') {
                                <div class="logistics-company-card__insight logistics-company-card__insight--providers">
                                    <span class="logistics-mi-marker" title="Magic Insight" aria-label="Magic Insight"><i class="fal fa-wand-sparkles"></i></span>
                                    <div class="logistics-provider-summary__heading">
                                        <span><i class="fal fa-truck-fast"></i></span>
                                        <small>{{ getLogisticsStructuredInsightLabel(panel.insight) }}</small>
                                    </div>
                                    <div class="logistics-provider-list">
                                        @for (provider of getLogisticsProviders(company); track provider.domain || provider.name || $index) {
                                        <span class="logistics-provider-chip" [title]="provider.services_provided?.join(', ') || provider.name">
                                            @if (provider.domain) {
                                            <img [src]="'https://www.google.com/s2/favicons?sz=64&domain=' + provider.domain"
                                                [alt]="provider.name + ' logo'" />
                                            } @else {
                                            <i class="fal" [ngClass]="getLogisticsProviderInsight(company).displaySchema?.fallback_icon || 'fa-truck'"></i>
                                            }
                                            <span>{{ provider.name }}</span>
                                        </span>
                                        }
                                        @if (getLogisticsProviderOverflowCount(company)) {
                                        <span class="logistics-provider-more">+{{ getLogisticsProviderOverflowCount(company) }}</span>
                                        }
                                    </div>
                                </div>
                                }
                                @if (panel.panelType === 'directional') {
                                <div class="logistics-company-card__insight logistics-company-card__insight--directional"
                                    [class.logistics-company-card__insight--geography]="panel.group.displayMode === 'geography'">
                                    <span class="logistics-mi-marker" title="Magic Insight" aria-label="Magic Insight"><i class="fal fa-wand-sparkles"></i></span>
                                    <div class="logistics-directional-insight__heading">
                                        <span class="logistics-company-card__insight-icon"><i class="fal {{ panel.group.icon }}"></i></span>
                                        <div>
                                            <strong class="logistics-insight-kind">{{ panel.group.label }}</strong>
                                            <small>{{ panel.group.period }}{{ panel.group.displayMode === 'metrics' ? ' movement' : '' }}</small>
                                        </div>
                                    </div>
                                    @if (panel.group.displayMode === 'geography') {
                                    <div class="logistics-geographical-insight__values">
                                        @for (field of panel.group.fields; track field.fieldKey) {
                                        <div>
                                            <span class="logistics-geographical-insight__direction">{{ field.label }}</span>
                                            <div class="logistics-geographical-insight__countries">
                                                @for (country of getLogisticsGeographicalBreakdown(field.insight); track country.countryCode) {
                                                <span [title]="country.countryName">
                                                    <strong>{{ country.countryCode }}</strong>
                                                    <small>{{ country.percentage | number:'1.0-1' }}%</small>
                                                </span>
                                                }
                                                @if (getLogisticsGeographicalOverflowCount(field.insight)) {
                                                <span class="logistics-geographical-insight__more">+{{ getLogisticsGeographicalOverflowCount(field.insight) }}</span>
                                                }
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    } @else {
                                    <div class="logistics-directional-insight__values">
                                        @for (field of panel.group.fields; track field.fieldKey) {
                                        <div>
                                            <span>{{ field.label }}</span>
                                            <strong>{{ formatLogisticsInsightNumber(field.insight, false) }}</strong>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                @if (panel.panelType === 'insight') {
                                <div class="logistics-company-card__insight">
                                    <span class="logistics-mi-marker" title="Magic Insight" aria-label="Magic Insight"><i class="fal fa-wand-sparkles"></i></span>
                                    <span class="logistics-company-card__insight-icon"><i class="fal {{ getLogisticsStructuredInsightIcon(panel.insight) }}"></i></span>
                                    <div>
                                        <small>{{ getLogisticsStructuredInsightLabel(panel.insight) }}</small>
                                        @if (panel.insight.displaySchema?.display_type === 'number' || panel.insight.displaySchema?.display_type === 'gauge') {
                                        <strong>{{ formatLogisticsInsightNumber(panel.insight) }}</strong>
                                        } @else if (getLogisticsInsightPills(panel.insight).length) {
                                        <div class="logistics-insight-pills">
                                            @for (pill of getLogisticsInsightPills(panel.insight).slice(0, 3); track pill) {
                                            <span>{{ pill }}</span>
                                            }
                                            @if (getLogisticsInsightPills(panel.insight).length > 3) {
                                            <span>+{{ getLogisticsInsightPills(panel.insight).length - 3 }}</span>
                                            }
                                        </div>
                                        } @else {
                                        <strong [innerHtml]="panel.insight.value | companyDataPipe:panel.insight.legacyKey:company.number:accountsSearchTerm:homepageSearchTerm:fullWebsiteSearchTerm:newsContaining"></strong>
                                        }
                                    </div>
                                </div>
                                }
                                }
                            </div>
                            }
                        </article>
                        }

                        @if (companyCount().locked_mi_companies && getPlaceholderRowCount() > 0) {
                        <aside class="logistics-locked-results">
                            <span><i class="fal fa-wand-sparkles"></i></span>
                            <div>
                                <strong>{{ companyCount().locked_mi_companies | number }} more companies match this search</strong>
                                <p>Unlock the existing logistics analysis to see who they are.</p>
                            </div>
                            <button type="button" (click)="unlockPlaceholderMagicInsights()">Get insights</button>
                        </aside>
                        }
                    </div>
                    } @else {
                    <div class="logistics-results-empty">
                        <span><i class="fal fa-radar"></i></span>
                        <h3>No matching companies yet</h3>
                        <p>Broaden one or two criteria, then run the search again.</p>
                        <button type="button" class="logistics-secondary-button" (click)="scrollToLogisticsFilters()">Refine search</button>
                    </div>
                    }

                    @if (!isLogisticsSearchLoading && maxPageNumber > 1) {
                    <nav class="logistics-results-pagination" aria-label="Company results pages">
                        <button type="button" (click)="previousPage()" [disabled]="pageNumber === 1">
                            <i class="fal fa-arrow-left"></i><span>Previous</span>
                        </button>
                        <label class="form-label">
                            <span>Page</span>
                            <input #logisticsPageInput type="number" min="1" [max]="maxPageNumber" [value]="pageNumber"
                                (keyup.enter)="definedPage(logisticsPageInput.value)" />
                            <span>of {{ maxPageNumber | number }}</span>
                        </label>
                        <button type="button" (click)="nextPage()" [disabled]="pageNumber === maxPageNumber">
                            <span>Next</span><i class="fal fa-arrow-right"></i>
                        </button>
                    </nav>
                    }
                </section>

            </div>
            </mat-drawer-content>
            @if(!isScreenTooSmall()){
            <mat-drawer #profilePreview [style.width]="previewDrawerWidth()" position="end"
            [mode]="logisticsHasSearched ? 'over' : 'side'"
            [opened]="profilePreviewIsOpen()" (openedChange)="drawerStateChanged($event)"
            >
                <button class="rounded-btn-base rounded-btn-white rounded-left-btn preview-drawer-close btn-p-sm no-focus-outline" (click)="toggleProfilePreview()" matTooltip="Close" [style.right]="logisticsHasSearched ? '0.75rem' : (previewDrawerWidth() === '820px' ? '825px': '590px')">
                    <i class="fal fa-right-to-bracket"></i>
                </button>
            @if (dataStore.companyNumberFromParent()) {
            <company-profile-page [companyNumberFromParent]="dataStore.companyNumberFromParent()" (endpointsLoaded)="triggerChangeDetection($event)"></company-profile-page>
            } @else if (!dataStore.companyNumberFromParent()) {
                <span>No Preview Available</span>
            }
            </mat-drawer>
        }
        </mat-drawer-container>
        }

    </div>

</div>

<div class="modal fade" id="searchResultsActionsModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header py-2 d-flex align-items-baseline">
                <h5 class="modal-title">Save search</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="input-group">
                    <ng-container *ngIf="isSuperUser">
                        <label class="input-group-text" style="font-size: 10px; border-radius: 8px 0 0 8px;height: 33px;">
                            <input type="checkbox" name="makeSavedSearchShared" value="false" [(ngModel)]="makeSavedSearchShared" />
                            <span>&nbsp;Shared across org?</span>
                        </label>
                    </ng-container>
                    <input type="text" class="form-control" style="height: 33px;" [style.border-radius]="!isSuperUser ? '8px 0 0 8px' : null" name="savedSearchName" [(ngModel)]="savedSearchName" placeholder="Choose a name">

                        <button class="rounded-btn-base rounded-btn-light btn-p-sm rounded-right-btn" type="button" (click)="saveSearch()">
                            <i class="fal fa-save"></i> Save
                        </button>

                </div>
            </div>
        </div>
    </div>
</div>

<tagging [selection]="actionSelection" modalId="dashboardTagModal"></tagging>
@if (showDownloadModal) {
<downloads [selection]="actionSelection"
    [inputParams]="{'totalCompaniesSelected': totalCompaniesSelected, 'totalCompanyCount': companyCount().count, 'hasSelectedTotalNumberMatchingFilter': hasSelectedTotalNumberMatchingFilter}"
    (downloadDataFetched)="triggerChangeDetection($event)"></downloads>
}
<custom-column-bulk-edit [selection]="actionSelection"
    [inputParams]="{'customColumns': customColumns, 'teamMembers': teamMembersForCustomColumns}"></custom-column-bulk-edit>
<export-to-crm [crmName]="crmExporterName" [selection]="actionSelection" modalId="dashboardExportToCRMModal"></export-to-crm>
<get-insights #getInsights [modulesInfo]="magicModuleNamesIds" [selection]="actionSelection"
  modalId="dashboardGetInsightsModal"
  [numberOfCompaniesMatchingSearchParams]="!isLoading().loadingCompanyCount ? companyCount().count : null"
  (completed)="handleGetInsightsCompleted($event)"></get-insights>


@if(pushMessagesService.showPopupPushMsg()) {
    <div class="modal fade" id="gr-popup-modal" tabindex="-1" role="dialog" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="align-self-end">
                    <button type="button" class="position-absolute rounded-btn-base rounded-btn-light btn-p-xs mt-1" style="z-index: 2; right: 0.25rem;" data-bs-dismiss="modal" aria-label="Close" (click)="pushMessagesService.closePopupWindow()" matTooltip="Hide for this session">
                        &times;
                    </button>
                </div>

                <div  class="ratio ratio-16x9">
                    <iframe class="" [src]="pushMessagesService.popupMsg.embed_url | safe" frameborder="0" allowfullscreen></iframe>
                </div>
                <div class="modal-footer p-0">
                    <small role="button" class="rounded-btn-base rounded-btn-dark-hover me-2" (click)="pushMessagesService.triggerIgnoreMsg(pushMessagesService.popupMsg)" data-bs-dismiss="modal" matTooltip="Don't show this message again">Ignore
                    </small>
                </div>
            </div>
        </div>
    </div>
}
